import { useQuery } from "@tanstack/react-query";
import { fetcher, fetcherUseMethod, fetchBoardTypeList, fetchBoardManageItem } from ".";

/*
* 공통 코드를 가져오는 훅
* 그룹 코드를 이용하여 코드 리스트를 가져온다.
* API 따라서 변경 /common/code/
* 또는 전체 주소를 파라미터로 사용하여도 된다.
*/
export const useCode = (codeType) => {
    return useQuery({
        queryKey: ['code', codeType],
        queryFn: () => fetcher(`/common/code/${codeType}`),
        select: (response) => {
            return response.data || {};
        },
        onError: (error) => {
            console.error("Error fetching useCode API contracts:", new Date().toISOString(), error);
        },
        staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
        refetchOnWindowFocus: false,
    });
};

export const useCodeUseMthod = (codeType, methodType='POST') => {
    return useQuery({
        queryKey: ['postCode', codeType],
        queryFn: () =>
            fetcherUseMethod('/common/code/', {
                method: methodType,
                body: { type: codeType },
        }),
        select: (response) => {
            return response.data || {};
        },
        onError: (error) => {
            console.error("Error fetching useCodeUseMthod API contracts:", new Date().toISOString(), error);
        },
        staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
        refetchOnWindowFocus: false,
    });
};

export const useBoardType = (isQna) => {
    return useQuery({
        queryKey: ["board-of-type-list"],
        queryFn: () => fetchBoardTypeList(),
        select: (response) => {
            if(isQna)
                return response?.data?.data.Results.filter(item => item.BoardType==='qna');
            else
                return response?.data?.data.Results.filter(item => item.BoardType!=='qna');
        },
        onError: (error) => {
            console.error("Error fetching Board Type List API contracts:", new Date().toISOString(), error);
        },
        staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
        refetchOnWindowFocus: false,
    });
};

export const useManageBoardInfoQuery = (manage_id) => {
    return useQuery({
        queryKey: ["board-manage-of-item", manage_id],
        queryFn: () => fetchBoardManageItem(manage_id),
        select: (response) => {
            return response.data.data || {};
        },
        onError: (error) => {
            console.error("Error fetching Board Manage item API contracts:", new Date().toISOString(), error);
        },
        staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
        refetchOnWindowFocus: false,
        enabled: manage_id > 0,
    });
};